import '@babel/polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import Snotify from 'vue-snotify'
import VeeValidate from 'vee-validate'
import store from './store'
import http from './utils/ajax'
import App from './App'
import router from './router'
import MavDirectives from '@/directives'
import MavValidations from '@/validations'
import MavComponents from '@/components/reusable/global'
import HopScotch from 'hopscotch'
import theme from '@/const/theme'
import '@fortawesome/fontawesome-free/css/all.min.css'
import VueChartist from 'vue-chartist'
import VuetifyToast from 'vuetify-toast-snackbar'
import JsonCSV from 'vue-json-csv'
import VueSanitize from 'vue-sanitize'
import VueShortKey from 'vue-shortkey'
import { msalPlugin } from './config/msalPlugin'

Vue.config.productionTip = false

// To allow use of this.$http
Vue.prototype.$http = http

// For easy of tracking mode
Vue.prototype.$mode = process.env.VUE_APP_MODE
document.title = store.state.app.projectTitle

// Tour Component
HopScotch.configure({
  showPrevButton: true,
  onError: () => {
    Vue.prototype.$toast.error('There is an error with the current tour. Please inform the System Administrator.')
  }
})
Vue.prototype.$tour = HopScotch

// Components Framework
Vue.use(Vuetify, {
  theme: theme[process.env.VUE_APP_MODE],
  iconfont: 'mdi'
})

// Validation Component (and init commonly used validation)
const validateConfig = {
  events: 'blur',
  fieldsBagName: 'veeFields'
}
Vue.use(VeeValidate, validateConfig)

// Toast Component (vuetify toast are not good enough)
// https://artemsky.github.io/vue-snotify/documentation/api/options.html#snotifyconfig
Vue.use(Snotify, {
  toast: {
    timeout: 3000,
    position: 'rightTop',
    newOnTop: false,
    closeOnClick: true
  }
})

const opts = {} // your options

const vueObj = new Vuetify(opts)

export default vueObj

// Snackbar Plugin 08-Feb
Vue.use(VuetifyToast, {
  $vuetify: vueObj.framework,
  x: 'right',
  y: 'top',
  color: 'info',
  icon: 'mdi-information-outline',
  iconColor: '',
  // classes: [
  //   'body-2'
  // ],
  timeout: 5000,
  dismissable: true,
  multiLine: true,
  vertical: true,
  queueable: false,
  showClose: true,
  closeText: '',
  closeIcon: 'mdi-close-circle',
  closeColor: '',
  slot: [],
  shorts: {
    custom: {
      color: 'purple'
    }
  },
  property: '$toast'
})

// Maverick Plugins
Vue.use(MavDirectives)
Vue.use(MavValidations)
Vue.use(MavComponents)

// AR: Added for Dashboard 16-Jan-2020
Vue.use(VueChartist)

// AR: Added to sanitize v-html 31-Oct-2020
Vue.use(VueSanitize)

// AR: Added for Dashboard 12-May-2020
Vue.component('downloadCsv', JsonCSV)

// AR: Added for Document Heading 15-Dec-2020
Vue.use(VueShortKey)

// Added for msal plugin
Vue.use(msalPlugin)

// Preload the app (base init)
store.dispatch('preLoadApp')

new Vue({
  vuetify: new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#009688',
          secondary: '#757575',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
          subprimary: '#800000'
        }
      }
    }
  }),
  router,
  store,
  render: h => h(App)
}).$mount('#app')
